import 'gsap';

import BezierEasing from 'bezier-easing';

import Modal from './modal';

import { qs, qsa, toggleClass, byId } from '../base/dom-utils';

class Menu extends Modal {

    constructor(el, opts) {
        super(el, opts);

        this.$els.menuWrap = qs(this.options.menuWrap, this.$el);
        this.$els.menuItems = qsa(this.options.menuItems, this.$el);
        this.$els.burger = byId(this.options.burger);
        this.$els.bolt = byId(this.options.bolt);
    }

    beforeInit() {

        const menuEase = BezierEasing(0.61, 0.01, 0.08, 0.99);

        this.on('change:isMenuOpen', (isOpen) => {

            this.setState('isModalOpen', isOpen);

            toggleClass(this.$els.bolt, 'is-active', isOpen);

            if (isOpen) {

                toggleClass(this.$els.burger, 'is-active', true);

                const enterTl = new TimelineMax();

                enterTl.set(this.$el, {
                    className: '+=is-open'
                })

                .to(this.$els.menuWrap, 0.7, {
                    scaleX: 1,
                    force3D: false,
                    ease: new Ease(menuEase),
                    onComplete: () => toggleClass(this.$els.burger, 'is-bottom', true)
                })

                .staggerTo(this.$els.menuItems, 0.25, {
                    x: 0,
                    opacity: 1,
                    force3D: false,
                    ease: Sine.easeOut
                }, 0.1, '-=0.15');

            } else {

                const exitTl = new TimelineMax({
                    onComplete: () => {

                        toggleClass(this.$el, 'is-open', false);

                        // put burger up
                        toggleClass(this.$els.burger, 'is-bottom', false);
                        // animate burg enter
                        toggleClass(this.$els.burger, 'is-entering', true);
                        // remove burger active class
                        toggleClass(this.$els.burger, 'is-active', false);

                        // ugly!!!
                        setTimeout(() => {
                            // reset entering
                            toggleClass(this.$els.burger, 'is-entering', false);
                        }, 750);
                    }
                });

                exitTl.to(this.$els.menuItems, 0.25, {
                    x: -20,
                    opacity: 0,
                    force3D: false,
                    ease: Sine.easeOut
                })

                .to(this.$els.menuWrap, 0.3, {
                    scaleX: 0,
                    force3D: false,
                    ease: Sine.easeOut
                });

            }

        });
    }

    getDefaultOptions() {
        return {
            menuWrap: '.c-nav__wrap',
            menuItems: '.c-nav__item',
            burger: 'header-burger',
            bolt: 'header-bolt'
        };
    }

    getInitialState() {
        return {
            isMenuOpen: false
        };
    }
}

export default Menu;


/** WEBPACK FOOTER **
 ** ./components/menu.js
 **/